module.exports = __webpack_public_path__ + "static/media/spike.abe521cd.jpg";